<template>
<div></div>
</template>

<script>
export default {
  name: 'leftCenterToday'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/leftCenterToday.vue